import React from "react";
import styled from "styled-components";


const Head = styled.div`
position: relative;
bottom: 1.6em;
  text-align: center;
  text-justify: center;
  h2{
    position: relative;
    top: 1em;
    font-weight:bold;
    color: #005a4b;
  }
  opacity: 0.77;
  width: 100%;
  height: 100px;
  background-color: #d7ebeb;
  
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  @media screen and (max-width: 500px) {
    height: auto;
    padding-bottom: 5px;
    h2{
    font-weight:bold;
    color: #005a4b;
    position: relative;
    top: 19px;
  }
  }
`;

class Header extends React.Component {
  render() {
    return (
      <Head>
        <h2>
          Service 
        </h2>
      </Head>
    );
  }
}
export default Header;
